"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.thumbnail = void 0;
var queryString = __importStar(require("query-string"));
var SERVER_URL = process.env.IMG_LITE_SERVER_URL || 'https://imglite.avantstay.com/';
var getImageAddress = function (url) {
    var isHttpUrl = /^http/i.test(url);
    if (isHttpUrl) {
        return encodeURIComponent(url);
    }
    var origin = globalThis && globalThis.location ? globalThis.location.origin : '';
    if (!origin) {
        return encodeURIComponent(url);
    }
    return encodeURIComponent(new URL(url, origin).toString());
};
var getSizingStep = function (size) {
    var minStep = 10;
    var firstThreshold = 200;
    if (size < firstThreshold) {
        return 1;
    }
    return Math.max(minStep, minStep * Math.pow(2, (1 + Math.ceil(Math.log(size / firstThreshold) / Math.log(2)))));
};
var thumbnail = function (url, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var _c = options.density, density = _c === void 0 ? 1 : _c, _d = options.height, height = _d === void 0 ? 0 : _d, _e = options.width, width = _e === void 0 ? 0 : _e, restOptions = __rest(options, ["density", "height", "width"]);
    var heightStep = getSizingStep(height);
    var widthStep = getSizingStep(width);
    var isLocalhost = /localhost/.test((_b = (_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.location) === null || _a === void 0 ? void 0 : _a.host) !== null && _b !== void 0 ? _b : '');
    var isLocalFile = isLocalhost && url && !/^http/i.test(url);
    var isBlobOrDataUrl = url && /^(blob|data):/i.test(url);
    var isSvg = url && /\.svg$/.test(url);
    if (!url || isLocalFile || isSvg || isBlobOrDataUrl) {
        return url;
    }
    var _height = height ? { height: Math.round(density * Math.ceil(height / heightStep) * heightStep) } : {};
    var _width = width ? { width: Math.round(density * Math.ceil(width / widthStep) * widthStep) } : {};
    var queryParams = Object.fromEntries(Object.entries(__assign(__assign(__assign({}, restOptions), _height), _width)).sort(function (_a, _b) {
        var a = _a[0];
        var b = _b[0];
        return a.localeCompare(b);
    }));
    return queryString.stringifyUrl({
        url: new URL(getImageAddress(url), SERVER_URL).toString(),
        query: queryParams,
    }, { skipEmptyString: true });
};
exports.thumbnail = thumbnail;
